import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

/**
 * CareTablet 用 Firebase 設定
 * 環境変数から取得（.env.local または .env.example を参照）
 * Firebase Console > プロジェクト設定 > 一般 > マイアプリ から config をコピーできます。
 */
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export const auth = getAuth(app);

export async function getAuthBearerHeaders(): Promise<{ Authorization: string }> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("ログインが必要です");
  }
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

/** Hosting→Functions では Authorization が落ちることがあるため、body 用 idToken も返す */
export async function getAuthIdToken(): Promise<string> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("ログインが必要です");
  }
  const token = await user.getIdToken();
  if (!token) {
    throw new Error("認証トークンの取得に失敗しました");
  }
  return token;
}

export { db };
